import React from 'react';
import { connect } from 'react-redux';

import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';

import { trackCustomMetric } from '../../metrics/track-params';

const { memoize } = Helpers;

const withPageComponents = (Component, options) => {
    const { components = [], device, storeDomain } = options || {};

    const pageComponents = (props) => {
        return <Component {...props} />
    }

    const mapStateToProps = (state, ownProps) => {
        const { slugInfo, storeDomain } = state;
        let propObj = components.reduce((r, c) => {
            const cmp = slugInfo.components[c];
            if (cmp) {
                r[c] = cmp;
            }
            return r;
        }, { category: slugInfo.category });
        if (device) {
            propObj.device = state.ui.device;
        }
        if (storeDomain) {
            propObj.storeDomain = storeDomain;
        }
        return propObj
    };

    const mapDispatchToProps = dispatch => {
        //TODO: add action for fetching components async
        return {
            trackCustomMetric: (eventName, params) => dispatch(trackCustomMetric(eventName, params))
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(withError(pageComponents));
};

export default withPageComponents;